export function toTitleCase(str: string | null | undefined) {
  return str?.replace(
    /\w\S*/g,
    (text) => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase()
  );
}

// function to initialize first letter of full name to uppercase
export function capitalizeInitials(str: string | null | undefined) {
  return str?.replace(
    /\w\S*/g,
    (text) => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase()
  );
}
export const capitalizeInitial = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1)?.toLowerCase();
};

export const allowDigitsOnly = (e: { key: string; preventDefault: () => void; }) => {
  if (!/[0-9]/.test(e.key)) {
    e.preventDefault();
  }
};

export const stripHtmlTags = (htmlString: string) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');
  return doc.body.textContent || "";
}
